import { render, staticRenderFns } from "./config-hang.vue?vue&type=template&id=7c3d19e4&"
import script from "./config-hang.vue?vue&type=script&lang=js&"
export * from "./config-hang.vue?vue&type=script&lang=js&"
import style0 from "./config-hang.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports